<script setup>
/**
 * FormControlModulestructureNumRows
 * Composition-based wrapper around the standard text form control.
 * Contextually exposes rows configuration rules when an entity type matches 'textarea',
 * sizing the element down to Bootstrap's grid span 4 layout automatically.
 */
import {onMounted} from 'vue'
import {useFormStore} from '@/stores/form'
import FormControlTypeText from '@/common/form-control-type/FormControlTypeText.vue'

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number, Array],
        default: null
    }
})

const formStore = useFormStore(props.formId)

// --- Lifecycle ---

onMounted(() => {
    if (!props.field || !props.currentData) return

    if (props.currentData.type === 'textarea') {
        // Size the layout field component down to grid width 4
        props.field.size = 4

        // TODO - This serves no purpose because the field will already have been saved before the type is set.
        // Once it's converted to a number field it can be removed anyway.
        formStore.setDefaultValue({
            name: props.field.name,
            value: '0'
        })
    } else {
        // Hide the configuration row if the schema target isn't a long-form textarea
        props.field.hidden = true
    }

    // TODO - Why is this field not a number field? I should check all sites and maybe convert.
})
</script>

<template>
    <FormControlTypeText v-bind="$props" v-if="!field.hidden"/>
</template>

<style scoped>
/* Grid formatting properties scale out of the base type wrapper */
</style>